export default {"src":"/login-app/[GIT_HASH]/_next/static/media/table_view.ad11a1ea.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};